/**
 * A lightweight composable for one-shot GraphQL mutations (non-cached).
 * Use this instead of raw $fetch when you need to call a mutation from a
 * component (forms, newsletter subscribe, etc.).
 *
 * For queries that need SSR caching and reactivity, keep using usePersistedFetch.
 */
export function useGqlMutation() {
  const runtimeConfig = useRuntimeConfig()
  const { locale } = useI18n()

  const apiUrl = runtimeConfig.public.httpEndpoint as string

  const mutate = async <TData = any>(
    operationName: string,
    variables: Record<string, any> = {},
    options: { language?: string } = {},
  ): Promise<{ data: TData | null; errors: any[] | null }> => {
    const lang = options.language ?? locale.value

    const res: any = await $fetch(apiUrl, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'content-language': lang,
      },
      body: {
        operationName,
        queryId: operationName,
        variables,
      },
    })

    const errors = res?.errors?.length ? res.errors : null
    const data: TData | null = res?.data ?? null

    return { data, errors }
  }

  return { mutate }
}
